import React from 'react';
import GpyComponent from './GpyComponent'
import {_GPY} from '../../../env.js'

const TIMEOUT = "_timeout";
class GpyToggleButton extends GpyComponent {

  constructor(props) {
	   super(props);

     this.state = {
            conf : {autoexpirytime : props.autoexpirytime===undefined?0: parseInt(props.autoexpirytime), onlyWarn: (props.warnOnly !== undefined &&  ( props.warnOnly === "true" ||  props.warnOnly === true )?true:false) , keyCode : props.keyCode},
            gpyComponentID: super.getId(),
			      active: false,
            warnBlink: true,
            timer : 0,
            activeTitle: this.props.activeTitle!==undefined?this.props.activeTitle: this.props.title,
            deactiveClass: props.deactiveClass !== undefined ?  props.deactiveClass : "btn btn-primary btn-sm btn-block",
            activeClass: props.activeClass !== undefined ?  props.activeClass : "btn btn-success btn-sm btn-block",
            activeWarnAktiveClass: props.activeWarnAktiveClass !== undefined ?  props.activeWarnAktiveClass : "btn btn-success btn-sm btn-block text-dark",
            activeWarnClass: props.activeWarnClass !== undefined ?  props.activeWarnClass : "btn btn-success btn-sm btn-block",
            pauseMode:false,

            captureCodeMode:false,
            keyCodeEditMode:false,
            editAutoexpirytimeMode:false,
            autoexpiryRestartCount : 0,
            dkeyCode: "",
            lastUpdate: "{}",
		 };
     this.state.dkeyCode = _GPY.getDisplayKeyCode(this.state.conf);
	  }


    componentDidMount() {

      if(this.props.scoreboard.config !== undefined) {
        this.setConfig(this.props.scoreboard.config[this.getStateName()]);
      }

      if(this.props.scoreboard !== undefined ){
         this.props.scoreboard.registerComponent(this.getStateName(),this);
         this.props.scoreboard.registerButton(this.getStateName(),this);
      };

      if(this.props.scoreboard !== undefined && this.getStateName() !== undefined) {
        if(this.props.scoreboard.state[this.getStateName()]!==undefined && this.props.scoreboard.state[this.getStateName()].visible) {
          //this.onActivate();
          this.setState({active : true});
        }


         var timeout = this.props.scoreboard.state[this.getStateName()+TIMEOUT]
         if(timeout !== undefined) {
           var intTimeOut = parseInt(timeout,10);
           if(intTimeOut>0) {
             this.setState({timer: intTimeOut});
             clearInterval(this.interval);
             this.interval = setInterval(() => this.tick(), (1000));
           }
         }
      }

      if(this.props.onCreate!==undefined) {
         this.props.onCreate(this);
      }
    }

    onChangeValue(obj){
      // console.log("onChangeValue condition :"+obj[this.props.condition] );
      if ( this.props.scoreboard !== undefined && this.props.condition !== undefined ) {
          //  this.setState({condition: obj[this.props.condition]});
      }
    }

    changeWarnOnly(e) {
      var conf = this.state.conf;
      conf.onlyWarn = e.target.checked;
      this.setState({conf:conf,dkeyCode:_GPY.getDisplayKeyCode(conf)});
    }

    changeAutoExpireTime(e) {
      var conf = this.state.conf;
      conf.autoexpirytime = parseInt(e.target.value);
      if(conf.autoexpirytime<0) conf.autoexpirytime = 0;
      this.setState({conf:conf});
    }

    disableEditMode(){
      this.setState({editAutoexpirytimeMode:false,keyCodeEditMode:false});
    }

    toggleKeyCodeEditMode(forceValue){
      if(forceValue!==undefined) {
        this.setState({editAutoexpirytimeMode:false,captureCodeMode:false,keyCodeEditMode:forceValue});
      } else {
        this.setState({editAutoexpirytimeMode:false,captureCodeMode:false,keyCodeEditMode:!this.state.keyCodeEditMode});
      }
    }

    toggleAutoexpirytimeEditMode(forceValue){
      if(forceValue!==undefined) {
        this.setState({keyCodeEditMode:false,editAutoexpirytimeMode:forceValue});
      } else {
        this.setState({keyCodeEditMode:false,editAutoexpirytimeMode:!this.state.editAutoexpirytimeMode});
      }
    }

    captureKeyCode(){
       this.setState({captureCodeMode:true});
    }

    getConfig() {
      return this.state.conf;
    }

    setConfig(c) {
      if(c!==undefined) {
        this.setState({conf:c,dkeyCode:_GPY.getDisplayKeyCode(c)});
      }
    }

    onKeyDown(e) {
      if(this.state.captureCodeMode){
        if(e.key === "Backspace") {
          var conf = this.state.conf;
          conf.keyCode = undefined;
          this.setState({conf:conf,captureCodeMode:false,dkeyCode:_GPY.getDisplayKeyCode(conf)});
          e.preventDefault();
          return;
        } else if(e.key !== "CapsLock" && e.key !== "Shift" && e.key !== "Control"  && !e.key.startsWith("Alt") && e.key !== "Meta"  && e.key !== "Enter"  && e.key !== "Escape") {

          var config = this.state.conf;
          config.keyCode = e.key;
          this.setState({conf:config,captureCodeMode:false,dkeyCode:_GPY.getDisplayKeyCode(config)});
          e.preventDefault();
          return;
        }
      }
      if(this.state.conf !== undefined && this.state.conf.keyCode !== undefined && this.state.conf.keyCode === e.key) {
          this.onButton();
          e.preventDefault();
          return;
      }
    }

    getStateName(){
      if(typeof (this.props.stateName)  === "function") {
        return this.props.stateName();
      }
      else return this.props.stateName;
    }

    blink() {
      this.setState({warnBlink: !this.state.warnBlink});
    }

    updateTimer(offset) {
      var ti = this.state.timer + offset;
      if( ti > this.state.conf.autoexpirytime ) {
        ti = this.state.conf.autoexpirytime;
      }
      if(ti<0) {
        ti = 0;
      }
      this.setState({timer: ti});
    }

    tick() {
      if(this.state.pauseMode===true) {
        clearInterval(this.interval);
        return;
      }
      if(this.state.timer <= 0) {
        clearInterval(this.interval);
        if( this.state.conf.onlyWarn === true ) {
            this.setState({timer: 0});
        } else {
          this.setState({active: false});
          this.onDeactivate();
          if(this.props.autoexpiryRestart!==undefined){
            console.log("doRestart");
            let milis = parseInt(this.props.autoexpiryRestart)
            let doRestart = false;

            if(this.props.autoexpiryRestartCount!==undefined) {
               if(this.state.autoexpiryRestartCount < this.props.autoexpiryRestartCount) {
                  doRestart = true;
                  this.setState({autoexpiryRestartCount:(this.state.autoexpiryRestartCount+1)});
               } else {
                 this.setState({autoexpiryRestartCount:0});
               }
            } else {
              doRestart = true;
            }

            if(doRestart) {
                this.restartInterval = setInterval(() => {
                  clearInterval(this.restartInterval);
                  if(this.props.prepareRestart!==undefined) {
                    this.props.prepareRestart();
                  }
                  this.setState({active: true});
                  this.onActivate();
                }, milis );
            }


          }
        }
      } else {
        var ti = this.state.timer - 1;
        this.setState({timer: ti});
        if(ti === 0 && this.state.conf.onlyWarn === true) {
          this.binterval = setInterval(() => this.blink(), (500));
        }
      }
    }

    onButton() {
       if(this.props.condition === undefined || this.props.condition()){
        if(this.state.active) {
          this.onDeactivate();
        } else {
          this.onActivate();
        }
      }
   }

   onData(key,data){
     if(data.gpyComponentID!==undefined && data.gpyComponentID !== this.state.gpyComponentID) {
       this.setState({active:data.visible});
     }
   }

   sendUpdate(){
     this.updateData();
   }

   updateData() {
     if(this.state.active) {
       var obj = {};
       var t = {};
       if(this.props.onUpdateData) {
          t = this.props.onUpdateData();
       } else {
         t = this.props.onActivate!==undefined?this.props.onActivate():{};
         delete t.visible;
       }
       t._UPDATE = true;
       t.gpyComponentID = this.state.gpyComponentID;
       var update = JSON.stringify(t, _GPY.replacer );
       if(update !== this.state.lastUpdate) {
         this.setState({lastUpdate:update},()=>{
             obj[this.getStateName()] = update;
             obj[this.getStateName() + TIMEOUT] = this.state.conf.autoexpirytime;
             obj['#TIME'] = this.props.getTime!==undefined?this.props.getTime():0;
             obj['#GAMEID'] = this.props.getGameId!==undefined?this.props.getGameId():-1;
             super.sendGameState(obj);
         })
       } else {
         console.log("Same Update Data, Droped" , this.getStateName());
       }
    }
   }

   onInit(o) {
     var obj = {};

     var t = this.props.onInit!==undefined?this.props.onInit():{};
     t.gpyComponentID = this.state.gpyComponentID;
     obj[this.getStateName()] = JSON.stringify(t,_GPY.replacer);

     obj[this.getStateName()+"_init"] = JSON.stringify(t,_GPY.replacer);
     super.sendGameState(obj);
   }

   pause(){
       clearInterval(this.interval);
       this.setState({pauseMode:true});
   }

   resume(){
      this.setState({pauseMode:false},()=>{
        if(this.state.conf.autoexpirytime !== undefined && this.state.conf.autoexpirytime > 0) {
           clearInterval(this.interval);
           this.interval = setInterval(() => this.tick(), (1000));
         }
     });
   }

   onActivate() {
    this.setState({active: true,pauseMode:false});

     var t = this.props.onActivate!==undefined?this.props.onActivate():{};
     if(this.state.conf.autoexpirytime !== undefined && this.state.conf.autoexpirytime > 0) {
        if(this.state.timer<=0){
          this.setState( {timer : this.state.conf.autoexpirytime }, ()=>{
            clearInterval(this.interval);
            if(t.nonAutoStart!==true) {
              clearInterval(this.interval);
              this.interval = setInterval(() => this.tick(), (1000));
            } else {
               this.tick();
            }
          });
        }
      }
      var obj = {};
      t.gpyComponentID = this.state.gpyComponentID;
      obj[this.getStateName()] = JSON.stringify(t,_GPY.replacer);
      obj[this.getStateName() + TIMEOUT] = this.state.conf.autoexpirytime;

      obj['#TIME'] = this.props.getTime!==undefined?this.props.getTime():0;
      obj['#GAMEID'] = this.props.getGameId!==undefined?this.props.getGameId():-1;
      super.sendGameState(obj);
   }

   isActive() {
      return this.state.active;
   }

   isRestartMode(){
     return this.restartInterval!==undefined;
   }

   onDeactivate() {
       this.setState({active: false});
       clearInterval(this.interval);
       clearInterval(this.binterval);
       this.setState( {timer : 0 } );
       var obj = {};
       var t = this.props.onDeactivate!==undefined?this.props.onDeactivate():{};
       t.gpyComponentID = this.state.gpyComponentID;

       obj[this.getStateName()] = JSON.stringify(t,_GPY.replacer);
       obj[this.getStateName() + TIMEOUT] = 0;
       obj['#TIME'] = this.props.getTime!==undefined?this.props.getTime():0;
       obj['#GAMEID'] = this.props.getGameId!==undefined?this.props.getGameId():-1;
       super.sendGameState(obj);
   }

	 render() {
     var enable = (val) => {
       if(this.props.condition === undefined || this.props.condition()){
         return (val);
       } else {
         return (val + " disabled");
       }
     };

     if(this.state.active){
          if(this.state.timer > 0 ){
            var percent = this.state.timer*100/this.state.conf.autoexpirytime;

            return (
              <button type="button" onClick={()=>{this.onButton()}} className={enable(this.state.activeClass)}>{this.state.activeTitle}{this.state.dkeyCode}
                  <div style={{backgroundColor:"#000",width:percent+"%",height:"2px"}}></div>
              </button>
            )
          } else {
            if(this.state.conf.onlyWarn) {
                if(this.state.warnBlink){
                  return (
                    <button style={{zIndex:100}} type="button" onClick={()=>{this.onButton()}} className={enable(this.state.activeWarnAktiveClass)}>{this.state.activeTitle}{this.state.dkeyCode}
                      <div style={{width:"100%",height:"2px"}}></div>
                    </button>
                  )
                } else {
                  return (
                    <button style={{zIndex:100}} type="button" onClick={()=>{this.onButton()}} className={enable(this.state.activeWarnClass)}>{this.state.activeTitle}{this.state.dkeyCode}
                      <div style={{width:"100%",height:"2px"}}></div>
                    </button>
                  )
                }

            } else {
              return (
                <button type="button" onClick={()=>{this.onButton()}} className={enable(this.state.activeClass)}>{this.state.activeTitle}{this.state.dkeyCode}
                  <div style={{width:"100%",height:"2px"}}></div>
                </button>
                )
          }
      }
    } else {

      if(this.state.keyCodeEditMode) {
            return (
              <button style={{zIndex:100}} type="button" onClick={()=>{this.captureKeyCode()}} className={this.state.captureCodeMode?"btn btn-danger btn-sm btn-block":"btn btn-outline-secondary btn-sm btn-block"}>
                {this.state.captureCodeMode?
                  <>press any key <span className="glyphicon glyphicon-hourglass"/></>
                  :
                  <>
                  {this.props.title}{this.state.dkeyCode} <span className="glyphicon glyphicon-edit"/>
                  </>
                }

                <div style={{width:"100%",height:"2px"}}></div>
              </button>
            )
        } else if(this.state.editAutoexpirytimeMode){
          return (
            <button style={{zIndex:100}} type="button" onClick={()=>{}} className={"btn btn-warning btn-sm btn-block"}>{this.props.title}{this.state.dkeyCode} <span className="glyphicon glyphicon-time" />
              <div>
                <div class="form-check">
                  <label className="form-check-label">Expire (seconds)</label>
                  <input type="number" className="form-control" onChange={(e)=>{this.changeAutoExpireTime(e)}} value={this.state.conf.autoexpirytime} placeholder="seconds"/>
                </div>
                <div className="form-check">
                  <input disabled={this.state.conf.autoexpirytime<=0} className="form-check-input" onChange={(e)=>{this.changeWarnOnly(e)}}  type="checkbox" value=""/>
                  <label className="form-check-label">OnlyWarn</label>
                </div>
              </div>
            </button>
          )
        } else {
            return (
              <button style={{zIndex:100}} type="button" onClick={()=>{this.onButton()}} className={enable(this.state.deactiveClass)}>{this.props.title}{this.state.dkeyCode}
                <div style={{width:"100%",height:"2px"}}></div>
              </button>
            )
        }
    }

}
}
export default GpyToggleButton;
